let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("19GFH")).then(() => parcelRequire('g72ue'));